/* eslint-disable react/sort-comp */
/* eslint-disable camelcase */
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import 'leaflet/dist/leaflet.css';
import L from 'leaflet';
import {} from 'mapbox-gl-leaflet';
import 'leaflet-fullscreen';
import 'leaflet-fullscreen/dist/leaflet.fullscreen.css';
import styles from '../modules/forms/components/attachments.module.scss';
import 'leaflet-polylinedecorator';
import 'leaflet.markercluster/dist/leaflet.markercluster';
import 'leaflet.markercluster/dist/MarkerCluster.css';
import 'leaflet.gridlayer.googlemutant/dist/Leaflet.GoogleMutant';
import icon from '../icons/formMarker.png';
import { uniqueID } from '../utils/helpers';
import { CUSTOM_MAP, custom_map_max_zoom_level, get_custom_map_url } from '../constants/mapSettings';

const MAP_BOX = 'map_box';
class FormsMap extends Component {
  ID = uniqueID('map');

  defaultConfig = {
    marker: false,
    circle: false,
    rectangle: false,
    polyline: false,
    circlemarker: false,
    polygon: false
  };

  async componentDidMount() {
    this.initializeMap();
  }

  componentWillUnmount() {
    if (this.map) this.map.remove();
  }

  initializeMap = () => {
    const { location, user, defaultlocation, shape, mapStyle } = this.props;
    let curLocation = [0, 0];

    // Determine safe center
    if (defaultlocation && defaultlocation.length > 0) {
      curLocation = [defaultlocation[1], defaultlocation[0]];
    } else if (location && location.coordinates && location.coordinates.length > 0) {
      if (shape === 'Point') {
        curLocation = [...location.coordinates];
      } else if (shape === 'Polygon') {
        // Assume GeoJSON [lng, lat] for polygon points based on existing code logic
        const firstPoint = location.coordinates[0]?.[0];
        if (firstPoint) {
            curLocation = [firstPoint[1], firstPoint[0]];
        }
      } else if (shape === 'LineString') {
         const firstPoint = location.coordinates?.[0];
         if (firstPoint) {
             curLocation = [firstPoint[1], firstPoint[0]];
         }
      }
    }

    this.map = L.map(this.ID, {
      center: curLocation,
      zoom: 15,
      fullscreenControl: true,
      attributionControl: false
    });
    if (user && user?.portal_authorized_airports?.length>0 && user?.portal_authorized_airports[0]?.airport_settings
      && user?.portal_authorized_airports[0]?.airport_settings?.map_style === MAP_BOX) {
      L.mapboxGL({
        accessToken: process.env.REACT_APP_MAPBOX_TOKEN,
        style: `${mapStyle?.mapbox_style || 'mapbox://styles/mapbox/satellite-v9'}`
      }).addTo(this.map);
    } else if (user?.portal_airport?.airport_settings?.map_style === CUSTOM_MAP) {
      L.tileLayer(get_custom_map_url(user?.portal_airport?.airport_settings?.custom_map_url), {
        maxZoom: custom_map_max_zoom_level
      }).addTo(this.map);
    } else if (mapStyle && mapStyle?.mapbox_style && mapStyle?.mapbox_style !== 'google') {
      L.mapboxGL({
        accessToken: process.env.REACT_APP_MAPBOX_TOKEN,
        style: mapStyle?.mapbox_style
      }).addTo(this.map);
    } else {
      L.gridLayer.googleMutant({ type: 'satellite', maxZoom: 20 }).addTo(this.map);
    }

    if (location.coordinates && location.coordinates.length > 0) {
      if (shape === 'Point') {
        const marker = new L.Marker(location.coordinates, {
          icon: new L.Icon({
            iconUrl: icon,
            iconAnchor: [25, 35]
          })
        });
        this.map.addLayer(marker);
        this.map.setView([...location.coordinates], 18);
      }
      if (shape === 'Polygon') {
        const latlang = [];
        location.coordinates[0].forEach((e) => {
          latlang.push([e[1], e[0]]);
        });
        const polygon = L.polygon(latlang).addTo(this.map);
        this.map.addLayer(polygon);
        this.map.fitBounds(polygon.getBounds());
      }
      if (shape === 'LineString') {
        const latlang = [];
        location.coordinates.forEach((e) => {
          latlang.push([e[1], e[0]]);
        });
        const polyline = L.polyline(latlang).addTo(this.map);
        this.map.addLayer(polyline);
        this.map.fitBounds(polyline.getBounds());
      }
    }
  }

  render() {
    return <div id={this.ID} className={styles.map} />;
  }
}

FormsMap.propTypes = {
  location: PropTypes.arrayOf(PropTypes.shape({}))
};

FormsMap.defaultProps = {
  location: []
};

const mapStateToProps = state => ({
  user: state.auth.profile
});

export default connect(mapStateToProps, {})(FormsMap);
